import React from 'react';

interface SpaceProps extends React.HTMLAttributes<HTMLDivElement> {
  /** The content to be rendered within the space */
  children: React.ReactNode;
  /** Layout direction: 'horizontal' (default) or 'vertical' */
  direction?: 'horizontal' | 'vertical';
  /** Gap between items (number in pixels or CSS string value) */
  size?: number | string;
  /** Alignment along the cross-axis: 'start', 'center', 'end', or 'baseline' */
  align?: 'start' | 'center' | 'end' | 'baseline';
  /** Whether children should wrap when there isn't enough space */
  wrap?: boolean;
}

const Space: React.FC<SpaceProps> = ({
  children,
  direction = 'horizontal',
  size = 6,
  align = 'start',
  wrap = false,
  className = '',
  ...restProps
}) => {
  // Calculate the gap value based on the provided size prop.
  const gapValue = typeof size === 'number' ? `${size}px` : size;
  const flexDirection = direction === 'horizontal' ? 'flex-row' : 'flex-col';

  // Map the align prop to the corresponding Tailwind CSS class.
  let alignClass = '';
  switch (align) {
    case 'start':
      alignClass = 'items-start';
      break;
    case 'center':
      alignClass = 'items-center';
      break;
    case 'end':
      alignClass = 'items-end';
      break;
    case 'baseline':
      alignClass = 'items-baseline';
      break;
    default:
      alignClass = 'items-start';
  }

  // Use Tailwind's wrapping utilities.
  const wrapClass = wrap ? 'flex-wrap' : 'flex-nowrap';

  return (
    <span
      className={`flex ${flexDirection} ${alignClass} ${wrapClass} ${className}`}
      style={{ gap: gapValue, display: 'inline-flex' }}
      {...restProps}
    >
      {children}
    </span>
  );
};

export default Space;

// import React from 'react';
// import { twMerge } from 'tailwind-merge';

// interface SpaceProps {
//   size?: 'small' | 'middle' | 'large' | number;
//   direction?: 'horizontal' | 'vertical';
//   align?: 'start' | 'end' | 'center' | 'baseline';
//   wrap?: boolean;
//   className?: string;
//   children: React.ReactNode;
// }

// const Space: React.FC<SpaceProps> = ({
//   size = 'middle',
//   direction = 'horizontal',
//   align,
//   wrap = false,
//   className,
//   children,
// }) => {
//   // Determine the space value based on size
//   let spaceValue: number;
//   if (typeof size === 'number') {
//     spaceValue = size;
//   } else {
//     const sizeMap: Record<string, number> = {
//       small: 8,
//       middle: 16,
//       large: 24,
//     };
//     spaceValue = sizeMap[size] || 8; // Default to 8 if size is invalid
//   }
//   const spaceClass = direction === 'horizontal' ? `space-x-${spaceValue}` : `space-y-${spaceValue}`;

//   // Determine the flex direction
//   const flexDirection = direction === 'horizontal' ? 'flex-row' : 'flex-col';

//   // Determine alignment, default to 'start'
//   const finalAlign = align ?? 'start';
//   const alignClass = `items-${finalAlign}`;

//   // Determine wrap
//   const wrapClass = wrap ? 'flex-wrap' : 'flex-nowrap';

//   // Combine all classes
//   const finalClass = twMerge(
//     'flex',
//     flexDirection,
//     spaceClass,
//     alignClass,
//     wrapClass,
//     className
//   );

//   return <div className={finalClass}>{children}</div>;
// };

// export default Space;